<template>
  <div class="social">
    <HeaderParticipant 
        :participants="participants" 
        :participant="participant" 
        @selectParticipants="selectParticipants" 
        @changeSelect="changeSelect"
    />
    <v-row :class="{ 'mt-4': !age18 }">
        <v-col md="12">
          <div v-for="part in participantList" :key="part.id" class="ml-2 mr-2 mb-2 social_container">
            <v-card class="elevation-4" :style="`background:${cardBGColor}`">
              <v-card-text>
                <HeaderCard :part="part"/>
                <v-row v-if="!isUnder13(part)">
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-facebook"
                      v-model="part.facebook"
                      :label="$t('social.facebook')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-twitter"
                      v-model="part.twitter"
                      :label="$t('social.twitter')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-linkedin-in"
                      v-model="part.linkedin"
                      :label="$t('social.linkedin')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-instagram"
                      v-model="part.instagram"
                      :label="$t('social.instagram')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-youtube"
                      v-model="part.youtube"
                      :label="$t('social.youtube')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fab fa-twitch"
                      v-model="part.twitch"
                      :label="$t('social.twitch')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fas fa-link"
                      v-model="part.kick"
                      :label="$t('social.kick')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" md="6" sm="12">
                    <v-text-field
                      prepend-inner-icon="fas fa-music"
                      v-model="part.tiktok"
                      :label="$t('social.tiktok')"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn
                      @click="updateSocial(part)"
                      :loading="isSaving(part)"
                      :disabled="isSaving(part)"
                      :color="`${buttonColor}`"
                      dark
                      class="mb-2"
                    >
                      <v-icon class="ic">&nbsp;fas fa-save</v-icon>
                      {{ $t("social.save") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">
                    <WarningAlert class="mb-0">
                      {{ $t("social.coppa_under_13_message") }}
                    </WarningAlert>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>        
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
  </div>
</template>

<script>
import AuthService from "../services/AuthService";
import SocialService from "../services/SocialService";
import Snack from "../components/notifications/Snack";
import { VCard, VCol, VRow, VBtn, VIcon, VTextField, VCardText } from 'vuetify/lib';
import GeneralService from "@/services/GeneralService";
import HeaderCard from "@/components/HeaderCard";
import { mapState } from "vuex";
import HeaderParticipant from "@/components/HeaderParticipant";
import WarningAlert from "@/components/alert/WarningAlert.vue";

export default {
  name: "Social",
  components:{
    Snack,
    VCard, VCol, VRow, VBtn, VIcon, VTextField, VCardText, 
    HeaderCard, HeaderParticipant, WarningAlert
  },
  data() {
    return {
      dynamicMenuItems: [],
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      userId: "",
      buttonColor: "#000",
      cardBGColor: "#f1f1f1",
      participantList: [],
      bandLoadingPartSelected: false,
      savingUsers: {}
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
  },
  mounted() {
    this.$emit("titlePage", "social.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    this.getParticipants();
  },
  methods: {
    loadImage(url) {
        const urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
        return urlImage;
    },
    isUnder13(part) {
      if (!part || !part.birthDate) return false;
      const birthDate = new Date(part.birthDate);
      if (Number.isNaN(birthDate.getTime())) return false;

      const nowDay = new Date();
      nowDay.setFullYear(nowDay.getFullYear() - 13);
      return birthDate > nowDay;
    },
    selectParticipants(){ 
      this.participantList = this.participantList.filter((el) => {
        const find = this.participant.find((ele) => { 
          return ele.userId ? el.userId == ele.userId : el.id == ele.id
        });
        return find ? true : false;
      });
      const usersId = this.participant.map((el) => { return el.userId; });
      this.getSocialUsers(usersId);
      AuthService.setAuthParticipants(this.userStore.id, this.participant); 
    },
    async getParticipants(){
      if(!this.bandLoadingParticipants) {
        if(this.userStore) {
          this.bandLoadingParticipants = true;
          this.$store.dispatch('setParticipantsAction');  
        } else {
          this.$store.dispatch('setUserAction');
        }
      }
    },
    async getSocial(userId) {
      await SocialService.getAll(userId).then(response => {
        if (response.data.success == 1 && response.data.message.length) {
          const social = response.data.message[0];
          const participant = this.participants.find(x => x.id === userId);

          if (participant) {
            Object.assign(participant, social);
          }
        }
      });
    },
    getSocialUsers(usersId) {
      SocialService.getSocialUsers({ usersId }).then(response => {
        if (response.data.success == 1) {
          this.participantList = this.participant.map((el) => {
            const data = response.data.message.find((el1) => el.userId == el1.id);
            return {
              ...el, 
              facebook: data ? data.facebook : null,
              instagram: data ? data.instagram : null,  
              twitter: data ? data.twitter : null,
              linkedin: data ? data.linkedin : null,
              youtube: data ? data.youtube : null,
              twitch: data ? data.twitch : null,
              kick: data ? data.kick : null,
              tiktok: data ? data.tiktok : null
            };
          });
        }
      });
    },
    isSaving(part) {
      const key = part.userId || part.id;
      return Boolean(this.savingUsers[key]);
    },
    async updateSocial(part) {
      const key = part.userId || part.id;
      this.$set(this.savingUsers, key, true);

      let data = {
        facebook: part.facebook,
        youtube: part.youtube,
        twitter: part.twitter,
        linkedin: part.linkedin,
        instagram: part.instagram,
        twitch: part.twitch,
        kick: part.kick,
        tiktok: part.tiktok,
        id: part.userId
      };

      try {
        const response = await SocialService.update(data);
        if (response.data.success == 1) {          
          this.showSnackBar(this.$t("transponder.msg_success_created"), "success");
        } else {
          let messageIndex = typeof response.data.message == 'string' ? response.data.message : response.data.message[0];
          let message = this.$te("social."+messageIndex) ? this.$t("social."+messageIndex) : messageIndex;
          this.showSnackBar(message, "error");
        }
      } catch (error) {
        const errorMessageIndex = error && error.response && error.response.data
          ? (typeof error.response.data.message == "string" ? error.response.data.message : error.response.data.message && error.response.data.message[0])
          : null;
        const errorMessage = errorMessageIndex && this.$te("social." + errorMessageIndex)
          ? this.$t("social." + errorMessageIndex)
          : "An error occurred";
        this.showSnackBar(errorMessage, "error");
      } finally {
        this.$set(this.savingUsers, key, false);
      }
    },
    showSnackBar(msg, color){
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 3000);
    },
    changeSelect(selectParts) {
      this.$store.commit('setParticipantsSelected', selectParts);
    }
  },
  computed: {
    ...mapState({
      content2(state) {
        return this.$t("common.selectParticipants.content_2", { livelapsId: state.session.userid })
      },
      age18: (state) => state.session.age18,
      userStore: (state) => state.session.user,
      participants: (state) => state.session.participants,
      participant: (state) => state.session.participantsSelected
    })
  },
  watch: {
    userStore(val) {
      if(val) {
        this.getParticipants();
      }
    },
    participant() {
      if(!this.bandLoadingPartSelected) {
        this.bandLoadingPartSelected = true;
        this.selectParticipants();
      }
    }
  }
};
</script>
<style>
  .ic{
    font-size: 15px !important;
    margin-right: 5px;
  }
  .social_container .v-text-field.v-text-field--enclosed .v-text-field__details{
    display: none;
  }
  .partImg{
    width: 40px;
    border-radius: 50%;
    height: 40px;
  }
  .partSpan{
    color: #000;
    position: absolute;
    top: 10px;
    left: 60px;
  }
</style>
